import React from "react";
import { useCruise } from "../context/CruiseContext";

const DJs = () => {
  const { DJS } = useCruise();
  const headliners = DJS.filter((d) => d.role === "Major Headliner");
  const main = DJS.filter((d) => d.role !== "Major Headliner");

  const Porthole = ({ dj, i }) => (
    <div
      key={`${dj.name}-${i}`}
      className="group flex flex-col items-center text-center"
      style={{ animationDelay: `${i * 80}ms` }}
    >
      <div className="relative w-40 h-40 sm:w-44 sm:h-44 flex items-center justify-center">
        <div className="absolute inset-0 rounded-full bg-[#E50914]/0 group-hover:bg-[#E50914]/10 blur-2xl transition-all duration-500" />
        <img
          src={dj.img}
          alt={dj.name}
          className={`relative w-full h-full object-contain drop-shadow-[0_12px_30px_rgba(0,0,0,0.6)] transition-transform duration-500 group-hover:-translate-y-1 ${
            dj.name.includes("DaVyne")
              ? "scale-[1.02] group-hover:scale-[1.12]"
              : "group-hover:scale-110"
          }`}
        />
      </div>
      <div className="mt-4">
        {dj.role === "Major Headliner" ? (
          <p className="font-cond uppercase text-[var(--hh-gold)] text-xs tracking-[0.25em]">Headliner</p>
        ) : (
          <p className="font-cond uppercase text-[var(--hh-gold)] text-xs tracking-[0.25em]">DJ</p>
        )}
        <h3 className="font-cond font-bold uppercase text-white text-lg leading-tight tracking-wide">
          {dj.name.replace(/^DJ\s/, "")}
        </h3>
        <p className="text-white/50 text-xs mt-1">{dj.role}</p>
      </div>
    </div>
  );

  return (
    <section id="djs" className="relative bg-[#0A0A0A] py-24">
      <div className="max-w-7xl mx-auto px-5">
        <div className="text-center mb-16">
          <p className="font-cond uppercase tracking-[0.4em] text-[#E50914] text-sm mb-3">On The Decks</p>
          <h2 className="font-display uppercase text-white text-4xl sm:text-6xl">
            The <span className="text-[#E50914]">DJs</span>
          </h2>
          <div className="flex justify-center mt-4">
            <span className="section-line" />
          </div>
          <p className="mt-5 text-white/60 max-w-2xl mx-auto">
            World-class selectors delivering nights of soulful, afro &amp; classic house music
            across the high seas.
          </p>
        </div>

        {headliners.length > 0 && (
          <div className="flex flex-wrap justify-center gap-10 sm:gap-16 mb-14">
            {headliners.map((dj, i) => (
              <Porthole key={`hl-${i}`} dj={dj} i={i} />
            ))}
          </div>
        )}

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8 md:gap-6">
          {main.map((dj, i) => (
            <Porthole key={`m-${i}`} dj={dj} i={i + headliners.length} />
          ))}
        </div>

        <p data-testid="dj-lineup-disclaimer" className="mt-12 text-center text-white/35 text-xs max-w-2xl mx-auto">
          Lineup is subject to change. Artists and DJs are confirmed in good faith but may be added,
          substituted or removed without notice. Your purchase is for the House Heads At Sea
          experience as a whole — not any individual performer — and no refunds are issued for
          lineup changes. See our <a href="/terms" className="underline hover:text-white">Terms &amp; Conditions</a>.
        </p>
      </div>
    </section>
  );
};

export default DJs;
